import React__default from 'react';
function BrandIcon(_a) {
  var brand = _a.brand;
  if (brand.logo) {
    return React__default.createElement("img", {
      className: "rounded",
      src: brand.logo,
      alt: "icon",
      style: {
        width: '24px',
        height: '24px'
      }
    });
  }
  function getInitials() {
    var str = brand.name;
    if (!str || !str.length) {
      return '';
    }
    var names = str.split(' ');
    if (!names.length) {
      return '';
    }
    if (names.length === 1 || names[1] === '-') {
      return names[0].substring(0, 2).toUpperCase();
    }
    return names[0].substring(0, 1).toUpperCase() + names[1].substring(0, 1).toUpperCase();
  }
  return React__default.createElement("div", {
    className: "rounded p-1 flex items-center justify-center font-semibold",
    style: {
      width: '24px',
      height: '24px',
      backgroundColor: '#ECF0F7',
      color: '#374F78'
    }
  }, getInitials());
}
export { BrandIcon as default };
//# sourceMappingURL=brandIcon.js.map
